(function ($) {
  if ($('.session_media_box')) {
    var time = $('.session_media_box').data('timeout');

    if (parseInt(time) <= 0) {
      $('.session_media_box').addClass('session_media_box--no_placeholder');
    } else {
      if (time < 2147483647) {
        // limitation of time parameter
        setTimeout(function () {
          $('.session_media_box').addClass('session_media_box--no_placeholder');
        }, time);
      }
    }
  }
})(jQuery);